import React from "react";
import ItemListContainer from "../components/ItemListContainer";

function Home() {
  return (    
      <ItemListContainer title="Bienvenidos a nuestro E-Commerce"/>
  );
}

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home.jsx